module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-a7c19f9bf4a0ea948e33f05344a9bf20.png";